module.exports = __webpack_public_path__ + "img/logo.2c798d20.png";